import type { SpoolStatus } from '@maker-toolchest/shared';
import { Badge } from '@/components/Badge';

interface SpoolStatusBadgeProps {
  status: SpoolStatus;
}

const statusConfig: Record<SpoolStatus, { variant: 'default' | 'success' | 'warning' | 'error' | 'info'; label: string }> = {
  IN_STORAGE: { variant: 'default', label: 'In Storage' },
  LOADED: { variant: 'info', label: 'Loaded' },
  IN_USE: { variant: 'success', label: 'In Use' },
  EMPTY: { variant: 'warning', label: 'Empty' },
  DISCARDED: { variant: 'error', label: 'Discarded' },
};

export function SpoolStatusBadge({ status }: SpoolStatusBadgeProps) {
  const config = statusConfig[status] || statusConfig.IN_STORAGE;
  return <Badge variant={config.variant}>{config.label}</Badge>;
}
